// src/Main.jsx
import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext'; 
import { SearchProvider } from './contexts/SearchContext';
import { LoaderProvider } from './contexts/LoaderContext';  // <-- Importá el LoaderProvider

export default function Main() {
  const [currentTheme] = useState(initialTheme);
  
  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <SearchProvider>
          <LoaderProvider>
            <AppRoutes />
          </LoaderProvider>
        </SearchProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="auth/*"
        element={
          isAuthenticated ? (
            <Navigate to="/admin/default" replace />
          ) : (
            <AuthLayout />
          )
        }
      />
      <Route
        path="admin/*"
        element={
          isAuthenticated ? (
            <AdminLayout />
          ) : (
            <Navigate to="/auth/sign-in" replace />
          )
        }
      />
      <Route path="/login" element={<Navigate to="/auth/sign-in" replace />} />
      <Route
        path="/"
        element={
          <Navigate
            to={isAuthenticated ? '/admin/default' : '/auth/sign-in'}
            replace
          />
        }
      />
      <Route
        path="*"
        element={
          <Navigate
            to={isAuthenticated ? '/admin/default' : '/auth/sign-in'}
            replace
          />
        }
      />
    </Routes>
  );
};
